import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=be4f2328&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=ts"
export * from "./ChatHeader.vue?vue&type=script&lang=ts"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=be4f2328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4f2328",
  null
  
)

export default component.exports